import { Skeleton } from '@radix-ui/themes';

export function EnvironmentCardSkeleton() {
  return (
    <div className='bg-gray-3 border-box ml-px flex min-h-[308px] w-full flex-col items-start rounded-fly-4 p-fly-5'>
      <Skeleton className='h-6 min-w-[30%]' />
      <Skeleton className='mt-fly-5 h-[112px] w-full max-w-full' />
      <Skeleton className='h-6 mt-fly-5 min-w-[30%]' />
    </div>
  );
}
